import React from "react";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { NormalText } from "../../../../components/TextParts";

export default function AdminComment(props) {
  return (
    <Box
      sx={{
        p: "20px",
      }}
    >
      <Typography sx={{ fontSize: "14px", fontWeight: "bold", mb: "20px" }}>
        運営会社からのコメント
      </Typography>
      <NormalText text={props.text}></NormalText>
    </Box>
  );
}
